module.exports = __webpack_public_path__ + "img/movie.b55b7065.png";